// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-notplay-helper-hint[data-v-1431f4dc]{display:flex;align-items:center;justify-content:center}.video-notplay-helper-text[data-v-1431f4dc]{background:rgba(0,0,0,.4);display:flex;align-items:center;border-radius:14px;width:292px;height:28px;font-size:12px;color:#fff;margin-right:6px}.video-notplay-helper-link[data-v-1431f4dc]{font-size:12px;color:#2c71fa;margin-left:8px}.video-notplay-helper-icon[data-v-1431f4dc]{font-size:28px}", ""]);
// Exports
module.exports = exports;
